import React from 'react';
import {
  Box,
  CircularProgress,
  Typography
} from '@mui/material';
import ChatMessage from './ChatMessage';
import TypingIndicator from './TypingIndicator';
import GenericOnboardingMessage from '../GenericOnboardingMessage';

const ChatMessageList = ({
  messages,
  isLoading,
  messagesEndRef,
  transcriptId,
  transcriptName
}) => {
  if (messages.length === 0) {
    return (
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 3
        }}
      >
        <GenericOnboardingMessage
          header={`Ask anything about${transcriptName ? ` ${transcriptName} transcript` : ' this transcript'}`}
          body="Brainstorm initial codes, summarize this transcript, or find relevant quotes."
          intercomArticleId={process.env['INTERCOM_ARTICLE_TRANSCRIPT_CHAT']}
          helpArticleText="Learn more about AI Chat"
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        // Custom scrollbar styling
        '&::-webkit-scrollbar': {
          width: 6,
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'divider',
          borderRadius: 3,
          '&:hover': {
            backgroundColor: 'text.secondary',
          }
        },
      }}
    >
      {messages.map((message) => (
        <ChatMessage
          key={message.id}
          message={message}
          transcriptId={transcriptId}
        />
      ))}
      
      {/* Typing indicator when AI is responding */}
      {isLoading && <TypingIndicator />}
      
      {/* Invisible div for auto-scrolling */}
      <div ref={messagesEndRef} />
    </Box>
  );
};

export default ChatMessageList;